import { render, staticRenderFns } from "./TituloDisciplinas.vue?vue&type=template&id=e06c1132&"
import script from "./TituloDisciplinas.vue?vue&type=script&lang=js&"
export * from "./TituloDisciplinas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports